import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { FormInputProps } from "../../models/form.model";

const filter = createFilterOptions();

export default function FormAutoSearch<T>(
  props: FormInputProps & {
    title?: string;
    options: T[];
    onAdd?: (value: string) => Promise<T>;
    multiple?: boolean;
    labelKey: string;
    valueKey: string;
    disabled?: boolean;
  },
) {
  const {
    name,
    control,
    title,
    label,
    required,
    helperText,
    setError,
    multiple,
    rules,
    disabled,
    options,
  } = props;
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, value = multiple ? [] : null },
        fieldState: { error },
        formState,
      }) => {
        return (
          <Autocomplete
            value={value}
            multiple={multiple}
            // isOptionEqualToValue={(option, v) => {
            //   if (typeof v === 'string') {
            //     return option[props.valueKey] === v;
            //   } else {
            //     return option[props.valueKey] === v[props.valueKey];
            //   }
            // }}
            disabled={disabled}
            filterSelectedOptions
            onChange={async (event, newValue) => {
              if (
                typeof newValue === "string" ||
                (newValue && newValue.inputValue)
              ) {
                if (props.onAdd) {
                  const v = await props.onAdd(newValue.inputValue || newValue);
                  onChange(v);
                }
              } else {
                onChange(newValue);
              }
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              if (props.onAdd && params.inputValue !== "") {
                filtered.push({
                  inputValue: params.inputValue,
                  label: `Add ${title || label} "${params.inputValue}"`,
                });
              }
              return filtered;
            }}
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                const op = props.options.find(
                  (a: any) => a[props.valueKey] === option
                ) as any;
                return op ? op[props.labelKey] : option;
              }
              if (option.inputValue) {
                return option.inputValue;
              }
              return option[props.labelKey];
            }}
            renderOption={(p, option, { index }) => {
              return (
                <li {...p} data-testid={`${name}-option${index}`}>
                  {option[props.labelKey] ||
                    option[props.valueKey] ||
                    option.label}
                </li>
              );
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                required={required}
                helperText={error ? error.message : helperText || null}
                error={!!error}
                inputProps={{
                  ...params.inputProps,
                  "data-testid": name,
                }}
              />
            )}
          />
        );
      }}
    />
  );
}
